import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react'
import logo from '../../../assets/msw-logo.png'
import axios from '../../../api/axios';
import Swal from 'sweetalert2';
import toast from '../../../components/sweetalert/Sweetalert';

const NDOTDisapproval = () => {
    const search = window.location.search;
    const param = new URLSearchParams(search);
    const token = param.get('token');
    const name = param.get('name');

    const [message, setMessage] = useState(null);
    const [reason, setReason] = useState(null);
    const [loading, setLoading] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [error, setError] = useState(false);

    const ndotDisapprovalMutation = useMutation({
        mutationFn: async (ndotData) => {
            const res = await axios.patch('ndot', ndotData, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            return res.data.response;
        },
        onSuccess: (data) => {
            setMessage(data);
            setSubmit(true);
            setLoading(false);
        },
        onError: (error) => {
            setError(true);
            setSubmit(true);
            setMessage(error.response?.data?.response);
            setLoading(false);
        }
    });

    const handleSubmitDisapproval = () => {
        if (!reason) {
            toast.fire({ icon: 'error', title: "Please input your reason" });
            return;
        }

        Swal.fire({
            text: `Are you sure you want to disapprove NDOT request of ${name}?`,
            icon: 'warning',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function(result) {
                return new Promise(function(resolve) {
                    if (result) {
                        ndotDisapprovalMutation.mutate({
                            status: 2,
                            statusreason: reason
                        });
                        resolve();
                    }  
                });
            }
        });
    }

    return (
        <div className="approval-disapproval disapproved">
            {submit 
                ? (
                    <>
                        <div className='icon'>
                            <i className={`fa ${error ? 'fa-exclamation-triangle' : 'fa-check-circle'}`}></i>
                        </div>
                        <p className='message'>
                            {message}
                        </p>
                    </>
                ) : (
                    <>
                        <div className='icon'>
                            <i className={`fa fa-exclamation-triangle`}></i>
                        </div>
                        <p className='message'><strong>DISAPPROVE</strong> NDOT request of <strong>{name}</strong>?</p>

                        <form>
                            <div className='form-group'>
                                <label>Reason</label>
                                <textarea name='reason' rows="3" cols="5" value={reason} onInput={(e) => { setReason(e.target.value) }} disabled={loading} ></textarea>
                            </div>
                            <div className='button-group'>
                                <button type='button' onClick={handleSubmitDisapproval}>
                                    <span>SUBMIT</span>
                                    {loading && (<i className='fa fa-spinner fa-spin'></i>)}
                                </button>
                            </div>
                        </form>
                    </>
                )
            }

            <div className='ad-footer'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <p>&copy; Megasportsworld 2025.</p>
            </div>
        </div>
    );
}

export default NDOTDisapproval;